import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { RootStore } from '../../../state/RootStore';
import { CartController } from '../../cart/CartController';
import { Product } from '@common/merch';

export const useStoreHandlers = (rootStore: RootStore, cartController: CartController) => {
  const navigate = useNavigate();
  const handleCollectionClick = useCallback((collectionId: string) => {
    const element = document.getElementById(`collection-${collectionId}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  const handleToggleSidebar = useCallback(() => {
    rootStore.applicationStore.toggleSidebar();
  }, [rootStore]);

  const handleCloseSidebar = useCallback(() => {
    rootStore.applicationStore.closeSidebar();
  }, [rootStore]);

  const handleAddToCart = useCallback(
    async (merchandiseId: string) => {
      await cartController.addToCart(merchandiseId);
    },
    [cartController]
  );

  const handleUpdateQuantity = useCallback(
    async (lineId: string, quantity: number) => {
      await cartController.updateQuantity(lineId, quantity);
    },
    [cartController]
  );

  const handleRemoveFromCart = useCallback(
    async (lineId: string) => {
      await cartController.removeFromCart(lineId);
    },
    [cartController]
  );

  const handleViewDetails = useCallback(
    (product: Product) => {
      navigate(`/product/${product.handle}`);
    },
    [navigate]
  );

  return {
    handleCollectionClick,
    handleToggleSidebar,
    handleCloseSidebar,
    handleAddToCart,
    handleUpdateQuantity,
    handleRemoveFromCart,
    handleViewDetails
  };
};
